<template>
  <div id="copiadeplano-pases-new-or-edit">
    <LmComponentLoading v-if="loading" fixed />
    <LmFormBuilder
      v-if="!tramiteIsLoading"
      ref="lmFormBuilder"
      :endpointUriwhereGetComponents="`formbuilder/${idFormBuilder}`"
      :endpointUriWhereGetValuesToLoadInEditMode="$route.params.id && `copiadeplano/movement/${$route.params.id}`"
      @formObjectToSendToServerChange="updateForm($event)"
      />
    <portal to="destination-after-title">
      <div class="col-12">
        <b-row v-if="tramiteIsLoading" class="mt-5">
          <b-col cols="6"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="6"><b-skeleton type="input"></b-skeleton></b-col>
        </b-row>
        <template v-else>
          <LmTextInput
            class="col-12 pl-0"
            v-model="tramite.Tramite"
            label="Trámite"
            :disabled="true"
          />
        </template>
      </div>
    </portal>
    <portal to="destination-0">
      <LmSuperPowerSelectV2
        class="col-6"
        urlPathFromGetOptions="/oficinas"
        label="Origen Nuevo"
        :disabled=true
        v-model="form.TramiteSource"
      />
    </portal>
    <portal to="button-submit">
      <LmButton
        id="boton-crear"
        value="Nuevo Pase"
        type="submit"
        buttonClass="btn-primary"
        @click.native="submit"
        />
    </portal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import lmFormMixinV2 from '@/mixins/lmFormMixinV2.js'
import lmToasts from '@/mixins/lmToasts.js'
import LmNumberInputGroup from '@/components/form/elements/LmNumberInputGroup'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'

export default {
  mixins: [lmFormMixinV2, lmToasts],
  components: {
    LmFormBuilder,
    LmTextInput,
    LmButton,
    LmNumberInputGroup,
    LmSuperPowerSelectV2

  },
  data () {
    return {
      tramiteIsLoading: true,
      propietarioIsLoading: false,
      form: {
        Tramite: null,
        TramiteSource: {}
      },
      tramite: {},
      formIsProcessing: false,
      initialForm: {}
    }
  },
  props: {
    idFormBuilder: {
      type: String,
      required: true
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    copiaDePlanoEndpointUri: {
      type: String,
      required: true
    }
  },
  computed: {
    disableSearch () {
      return !this.form.PropietarioTipoDocumento?.id
    },
    showPropietario () {
      return this.form.TipoSolicitante.id !== '1'
    }
  },
  validations: {
    form: {
      Tramite: {
        required
      },
      TramiteSource: {
        required
      }
    }
  },
  methods: {
    async submit () {
      const lmFormBuilderValidations = this.validationForm(this.$refs.lmFormBuilder.$v, false)
      const formValidation = this.validationForm(this.$v, false)
      await Promise.all([lmFormBuilderValidations, formValidation])
      try {
        this.loading = true
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`${this.newOrEditEndpointUri}/${this.$route.params.id}`, this.form)
          this.lmToastSuccessInternalLink(`/obras/copiadeplano/${this.form.Tramite}/${this.$route.params.id}`, 'Nuevo pase generado', 'Se guardó exitosamente')
        } else {
          const r = await commonsApi.axiosPostWrapper(`${this.newOrEditEndpointUri}/`, this.form)
          this.lmToastSuccessInternalLink(`/obras/copiadeplano/${this.form.Tramite}/${r?.data?._id}`, 'Nuevo pase generado', 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.loading = false
          this.$router.push('/obras/copiadeplano')
        }, 650)
      } catch (error) {
        this.showToastFormError()
      }
    },
    async setForm () {
      this.showLoading()
      await commonsApi.axiosGetWrapper(`${this.copiaDePlanoEndpointUri}${this.$route.params.tramite}`)
        .then(resp => {
          this.tramite = resp.data
          this.form.Tramite = this.tramite.Tramite
          this.form.TramiteSource = this.tramite.TramiteSource
        })
        .catch(e => {
          this.tramiteIsLoading = false
        })
      if (this.isOnEditMode) {
        await this.activeEditMode({
          path: this.newOrEditEndpointUri,
          id: this.$route.params.id,
          paramsMode: true
        })
      } else {
        setTimeout(() => {
          this.$v.$reset()
        }, 350)
      }
      this.tramiteIsLoading = false
      this.hideLoading()
    },
    updateForm (formDataFromLmFormBuilder) {
      for (const key in formDataFromLmFormBuilder) {
        this.form[key] = formDataFromLmFormBuilder[key]
      }
    }
  },
  async created () {
    this.isOnEditMode = !!this.$route.params.id
    await this.setForm()
    await this.$nextTick()
    for (const key in this.$refs.lmFormBuilder.formObjectToSendToServer) {
      const value = this.$refs.lmFormBuilder.formObjectToSendToServer[key]
      this.$set(this.form, key, value)
    }
  }
}
</script>
<style lang="sass" scoped>
  .search-prop-doc
    margin-top: 2rem !important
</style>
